import * as React from "react";
import { FieldNav } from "../components/FieldNav.js";
import { FieldFooter } from "../components/FieldFooter.js";
import { MailtoContact } from "../components/MailtoContact.js";
import { useDocumentTitle } from "../hooks/useDocumentTitle.js";
import { SEO_TITLES } from "../lib/seo-titles.js";
import "../styles/landing-field.css";
import "../styles/content-pages-field.css";

// Confirm before relying on these: legal entity / operator name, the
// governing-law state (Texas), and that the team@ inbox is monitored.
export function TermsRoute(): React.ReactElement {
  useDocumentTitle(SEO_TITLES["/terms"]);
  return (
    <div className="v-field">
      <FieldNav />
      <main id="main" className="v-field-c__page">
        <div className="container">
          <span className="v-field-c__eyebrow">Legal</span>
          <h1 className="v-field-c__title">Terms of Use</h1>
          <p className="v-field-c__updated">Effective June 6, 2026</p>
          <p className="v-field-c__lede">
            By using Sports Academy Games you agree to these terms. The short version: learn, have
            fun, don't break it.
          </p>
          <div className="v-field-c__prose">
            <h2>Using the games</h2>
            <p>
              Use the service to learn and play. Don't cheat the scoring, disrupt other players,
              copy or resell our games or content, or try to get around the limits that keep the
              service running. If you're under 18, use it with a parent, guardian, or school.
            </p>

            <h2>Premium subscriptions</h2>
            <p>
              Premium is a paid monthly subscription, billed through Stripe at the price shown when
              you subscribe. It renews automatically until you cancel; you can cancel anytime and
              keep access through the period you've paid for. Payments are non-refundable except
              where the law requires otherwise.
            </p>

            <h2>As-is</h2>
            <p>
              Each game is made by a credited author and provided as-is — we can't guarantee it fits
              a particular grade or curriculum. To the extent the law allows, the service is
              provided without warranties and we're not liable for indirect damages.
            </p>

            <h2>Changes, law, and contact</h2>
            <p>
              We may update the service and these terms; we'll update the date above. These terms
              are governed by the laws of the State of Texas, USA. Questions? Email{" "}
              <MailtoContact />.
            </p>
          </div>
        </div>
      </main>
      <FieldFooter />
    </div>
  );
}
